// (C) Copyright 2020 MediaWink, LLC

const GRAY40 = '#666666';
export { GRAY40 };
